module.exports = __webpack_public_path__ + "img/scene3.8de69340.gif";